import { render } from "./sms_management.vue?vue&type=template&id=5ce8f1b8&scoped=true&ts=true"
import script from "./sms_management.vue?vue&type=script&lang=ts"
export * from "./sms_management.vue?vue&type=script&lang=ts"

import "./sms_management.vue?vue&type=style&index=0&id=5ce8f1b8&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce8f1b8"]])

export default __exports__